import { BPS_DENOMINATOR, floorFee } from '@morfi/market-math';

export interface FoundingFundQuote {
  readonly amountD6: bigint;
  readonly feeD6: bigint;
  readonly totalD6: bigint;
}

/** Exact fee-on-top quote matching the on-chain backing instruction. */
export function quoteFoundingFund(amountD6: bigint, feeBps: number): FoundingFundQuote {
  const feeD6 = floorFee(amountD6, BigInt(feeBps), BPS_DENOMINATOR);
  return { amountD6, feeD6, totalD6: amountD6 + feeD6 };
}

/** Largest net backing amount whose fee-on-top total fits the wallet balance. */
export function maxFoundingFundAmountD6(balanceD6: bigint, feeBps: number): bigint {
  let low = BigInt(0);
  let high = balanceD6;

  while (low < high) {
    const candidate = (low + high + BigInt(1)) / BigInt(2);
    if (quoteFoundingFund(candidate, feeBps).totalD6 <= balanceD6) low = candidate;
    else high = candidate - BigInt(1);
  }

  return low;
}
